module.exports = __webpack_public_path__ + "static/media/HaCheon.a1b80853.jpg";